// extracted by mini-css-extract-plugin
export var logos = "logos-module--logos--18G_l";
export var list = "logos-module--list--1OZNe";
export var jsAnimInit = "logos-module--jsAnimInit--3kHQP";
export var item = "logos-module--item--3IwuN";